import { ReactElement, ReactNode } from "react";
import styles from "./toast.module.scss";
import CloseIcon from "@icons/closeIconV2.svg";

export const Toast = (props: Props): ReactElement => {
  return (
    <div className={styles["wrapper"]}>
      {props.icon && <div className={styles["iconPosition"]}>{props.icon}</div>}

      <div className={styles["content"]}>
        <div className={styles["texts"]}>
          {props.title && <p className={styles["title"]}>{props.title}</p>}

          {props.desc && <p className={styles["desc"]}>{props.desc}</p>}
        </div>

        {props.actions && (
          <div className={styles["actions"]}>{props.actions}</div>
        )}
      </div>

      {props.onClose && (
        <div className={styles["closePosition"]}>
          <button className={styles["close"]} onClick={props.onClose}>
            <CloseIcon />
          </button>
        </div>
      )}
    </div>
  );
};

interface Props {
  icon?: JSX.Element;
  title?: string | ReactNode;
  desc?: string;
  extraContent?: JSX.Element;
  onClose?: () => void;
  actions?: JSX.Element;
}
